<template>
  <div
    style="height: 100%;"
    class="pa-4"
  >
    <portal to="app-header">
      <div class="d-flex">
        <router-link
          to="/masonry/demo1"
          class="mr-2"
        >
          column方案
        </router-link>
        <router-link
          to="/masonry/demo2"
          class="mr-2"
        >
          flex方案
        </router-link>
        <router-link
          to="/masonry/demo3"
          class="mr-2"
        >
          flex/js
        </router-link>
        <router-link
          to="/masonry/demo4"
          class="mr-2"
        >
          flex水平
        </router-link>
        <router-link
          to="/masonry/demo5"
          class="mr-2"
        >
          grid方案
        </router-link>
        <router-link
          to="/masonry/demo6"
          class="mr-2"
        >
          grid+js
        </router-link>
        <VSpacer />
        <a
          class="ml-2"
          href="https://webkit.org/blog/15269/help-us-invent-masonry-layouts-for-css-grid-level-3/"
        >webkit的教程</a>
        <a
          class="ml-2"
          href="https://css-tricks.com/piecing-together-approaches-for-a-css-masonry-layout/"
        >参考 css-tricks</a>
      </div>
    </portal>
    <router-view />
  </div>
</template>

<script>

export default {
}
</script>

<style>

</style>